<div *ngIf="showDynamicInfo" class="circle" cdkOverlayOrigin #showInfoTrigger="cdkOverlayOrigin" (click)="isOpen = true">
  <svg [icon]="icons.Warning" class="svg24 white-color" />

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayPositions]="cdkPosition"
    [cdkConnectedOverlayOrigin]="showInfoTrigger"
    (backdropClick)="onBackdropClick()"
    [cdkConnectedOverlayOpen]="isOpen"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="transparent-backdrop"
  >
    <div class="container">
      <svg [icon]="icons.Warning" class="svg24 white-color" />
      <div class="text-container">
        Содержимое динамических наборов данных обновляется с периодичностью, приближенной к реальному времени. Для получения актуальных сведений
        необходимо обновить страницу.
      </div>
      <button class="btn-empty" (click)="onBackdropClick()">
        <svg [icon]="icons.Close" class="svg24 white-color" />
      </button>
      <button (click)="dontShow()" class="btn-secondary small mt12 button white-color">Больше не показывать</button>
    </div>
  </ng-template>
</div>
